import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Heading extends PureComponent {
    render() {
        const {
            children,
            className,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            [className]: true
        });

        return (
            <h2 className={classNames} {...props}>
                {children}
            </h2>
        );
    }
}

Heading.defaultProps = {
    className: 'h3'
};

export default Heading;
